<script>
import { mapActions } from 'vuex';
import BaseAutocompleteSearchRequestFilter from '@/modules/_global/_components/filters/BaseAutocompleteSearchRequestFilter.vue';

export default {
  name: 'CustomerSelect',

  extends: BaseAutocompleteSearchRequestFilter,

  props: {
    buildingComplexId: {
      type: Number,
      required: true
    },
    customer: {
      type: String,
      default: ''
    },
    massMarket: {
      type: [Boolean, Number],
      default: false
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.search = this.customer || '';
    });
  },

  methods: {
    ...mapActions('booking_reservations', ['getFilteredCustomers']),

    getData(search) {
      let params = { search: search };

      if (!this.massMarket) {
        params.building_complex = this.buildingComplexId;
      }
      return this.getFilteredCustomers(params).then(({ data }) => {
        return data.data;
      });
    }
  }
};
</script>
